import React from 'react';
import { useSubscription } from '../contexts/SubscriptionContext';
import { useNavigate } from 'react-router-dom';
import Icon from '../components/AppIcon';
import Button from '../components/ui/Button';

const useProAccess = () => {
  const { checkAccess, hasActiveSubscription, loading } = useSubscription();
  const navigate = useNavigate();

  const requireProAccess = () => {
    const hasAccess = checkAccess('pro');
    
    if (!hasAccess) {
      return {
        hasAccess: false,
        component: (
          <div className="flex items-center justify-center min-h-screen">
            <div className="text-center max-w-md">
              <div className="w-16 h-16 bg-warning/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Lock" size={32} className="text-warning" />
              </div>
              <h2 className="text-2xl font-bold text-foreground mb-2">Pro Feature</h2>
              <p className="text-muted-foreground mb-6">
                This feature is available for Pro users only. Upgrade your account to access advanced features and higher limits.
              </p>
              <Button 
                iconName="Crown"
                onClick={() => navigate('/profile?upgrade=true')}
              >
                Upgrade to Pro
              </Button>
            </div>
          </div>
        )
      };
    }

    return { hasAccess: true, component: null };
  };

  return {
    checkAccess,
    hasActiveSubscription,
    loading,
    requireProAccess
  };
};

export default useProAccess;
